import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const CardMaterial = styled.div`
  background: ${theme.colors.neutral.white};
  border-radius: ${theme.shapes.borderRadius.md};
  padding: ${theme.spacing.xm};
  margin-bottom: 130px;

  .materialTitle {
    font-size: ${theme.typography.sizes['2md']};
    line-height: 27px;
    margin: auto 0;
  }

  .deliveryHeader {
    display: grid;
    grid-template-columns: 1fr 280px 390px;
    grid-gap: ${theme.spacing.xm};
    margin-bottom: ${theme.spacing.lg};
    color: ${theme.colors.neutral.high};
    @media only screen and (max-width: ${theme.breakpoints.lg}px) {
      grid-template-columns: 1fr 2fr 2fr;
    }
  }
`

export const BoxColumn = styled('div')`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  div:last-of-type hr {
    margin-bottom: 0;
  }
`

export const BowRow = styled.div`
  display: flex;
  flex-direction: column;
`

export const TamanhosStyled = styled('div')`
  .column {
    display: flex;
    flex-direction: column;
    margin-bottom: ${theme.spacing.xm};
    flex-grow: 0;
    margin-right: ${theme.spacing.xm};
    background: red;
  }
`

export const LabelStyled = styled('div')`
  font-weight: ${theme.typography.weight.lg};
  font-size: ${theme.typography.sizes.xs};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${theme.spacing.xs};
`
